import styled from 'styled-components';

export const IconWrapper = styled.div`
  opacity: 0.3;

  &:hover {
    opacity: 1;
    transition: background 200ms ease-in;
    cursor: pointer;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Icon/styles.js